export const HEADER_INITIATOR_TYPE = {
  HEADER: 'headerOutline',
  ANNOUNCEMENT: 'headerAnnouncementOutline',
};
